function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
       var newQtyElements = document.querySelectorAll('.sticky-quantity');
    newQtyElements.forEach(function(newQty) {
       newQty.value = this.input.value;
    }, this);
    var newQtyLabel = document.querySelector('.quantity-label');
   if (newQtyLabel) { 
    var newQtyLabelNumber = 12;
    var nxtyLabelNumber = 600;
    var inputValueNumber = parseInt(this.input.value, 10);
    var multipliedValue = newQtyLabelNumber * inputValueNumber;
    var multipliedGrams = nxtyLabelNumber * inputValueNumber;
    newQtyLabel.innerHTML = ` Box (${multipliedValue} bars - ${multipliedGrams}g)`;
   }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages -1 ;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      let linkCounter = document.querySelector('.slider-counter__link--active');
      if(linkCounter) {
      link.classList.remove('slider-counter__link--active');
      }
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    const needToChangeUrl = this.getAttribute("changeurl");
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if(needToChangeUrl === null) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

updateMasterId() {
  this.currentVariant = this.getVariantData().find((variant) => {
    return !variant.options
      .map((option, index) => this.options[index] === option)
      .includes(false);
  });

  console.log('available:', this.currentVariant?.available);
}

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source) {
          const sourcePackSize = source.querySelector('.pack-size');
        const destiantionPacksize = document.querySelector(".cstmOptions.selected");
        const valuePackSize = destiantionPacksize.getAttribute('cstm-packsie-metadata');
        if (sourcePackSize && destiantionPacksize) {
          if (valuePackSize != null) {
             sourcePackSize.innerHTML = valuePackSize;
          }
        }
        }   
        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
  const section = this.closest('section') || document;

  const productForm =
    document.getElementById(`product-form-${this.dataset.section}`) ||
    section.querySelector('form[action*="/cart/add"]');

  const addButton =
    productForm?.querySelector('[name="add"]') ||
    productForm?.querySelector('button[type="submit"]') ||
    productForm?.querySelector('.product-form__submit') ||
    section.querySelector('[name="add"], .product-form__submit');

  console.log('productForm:', productForm, 'addButton:', addButton);
  if (!addButton) return;

  const HRXBtn = addButton.querySelector('.cta-submit-nw-hrx-dummy');
  const addButtonText =
    addButton.querySelector(':scope > span') ||
    addButton.querySelector('span') ||
    addButton;

  if (disable) {
    addButton.setAttribute('disabled', 'disabled');
    if (text) addButtonText.textContent = text;
  } else {
    addButton.removeAttribute('disabled');
    addButtonText.textContent = HRXBtn
      ? 'ADD TO CART'
      : (window.variantStrings?.addToCart || 'Add to cart');
  }

  const scope = productForm || section;
  scope
    .querySelectorAll('.shopify-payment-button button, .shopify-payment-button__button, .buy-now, [name="buy-now"]')
    .forEach((btn) => {
      if (disable) btn.setAttribute('disabled', 'disabled');
      else btn.removeAttribute('disabled');
    });

  if (!modifyClass) return;
}

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
     console.log('VAR',this.variantData);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
            setupVariantSelectors();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}
function setupVariantSelectors() {
  const products = document.querySelectorAll('custom-variant-selector');
  products.forEach((product) => {
    const variantSpans = product.querySelectorAll('.new_var_select');
    variantSpans.forEach(function(span) {
      span.addEventListener('click', function(event) {
        event.preventDefault();
        variantSpans.forEach(function(s) {
          s.classList.remove('active');
        });
        span.classList.add('active');
        const variantId = span.getAttribute('variant-new-attr');
        const variantPrice = span.getAttribute('variant-price-attr');
        const priceNumber = parseFloat(variantPrice.replace(/[^0-9.-]/g, ''));
        const result = priceNumber / 100;
        const variantComPrice = span.getAttribute('variant-comp-price-attr');
        const priceComNumber = parseFloat(variantComPrice.replace(/[^0-9.-]/g, ''));
        const resultCom = priceComNumber / 100;
        const altText = span.getAttribute('variant-image');
        let cardWrapper = span.closest('.card-wrapper');
        if (cardWrapper) {
          let quickAddSubmit = cardWrapper.querySelector('.quick-add__submit');
          if (quickAddSubmit) {
            let inputId = cardWrapper.querySelector('input[name="id"]');
            if (inputId) {
              inputId.value = variantId;
            }
          }
          let quickAddPrice = cardWrapper.querySelector('.price__sale');
          console.log(quickAddPrice);
          if (quickAddPrice) {
            let price = cardWrapper.querySelector('.price-item--sale');
            if (price) { 
              price.textContent = '₹' + result;
            }
            let Comprice = cardWrapper.querySelector('.compare--cssm--new');
            console.log('Comprice>>>', Comprice);
            if (Comprice && !isNaN(resultCom)) {
              Comprice.textContent = '₹' + resultCom;
              Comprice.classList.add('compare--cssm--newss');
            }
          }
          let changeSrc = cardWrapper.querySelector('.media');
          console.log('changeSrc>>>', changeSrc);
          if (changeSrc) {
            let variantSc = cardWrapper.querySelector('img[srcset]');
            if (variantSc && altText != '') {
              variantSc.setAttribute('srcset', altText);
            }
          }
        }
      });
    });
  });
}
customElements.define('product-recommendations', ProductRecommendations);


  function startTimer() {
    const now = new Date();
    const currentTime = now.getTime();
    const targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 0, 0).getTime();

    if (currentTime > targetTime) {
      document.querySelector('.Cart_Time').style.display = "none";
     var timerIn = document.querySelector('.variant-pop-box .countdown-on'); 
    if (timerIn) {  
      document.querySelector('.variant-pop-box .countdown-on').style.display = "none";
    }
      return;
    }

    let secondsLeft = Math.floor((targetTime - currentTime) / 1000);

    function timer() {
      const hours = Math.floor(secondsLeft / 3600);
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      if (secondsLeft <= 0) {
        document.querySelector('.Cart_Time').style.display = "none";
        var timerIn = document.querySelector('.variant-pop-box .countdown-on');
        if (timerIn) {
        document.querySelector('.variant-pop-box .countdown-on').style.display = "none";
        }
        clearInterval(timerInterval);
        return;
      }

      document.querySelectorAll(".countdown-text").forEach((element) => {
        element.innerHTML = (hours < 10 ? "0" : "") + hours + ": " + 
                            (minutes < 10 ? "0" : "") + minutes + ": " + 
                            (seconds < 10 ? "0" : "") + seconds + " hours!";
      });

      secondsLeft--;
    }

    timer();
    const timerInterval = setInterval(timer, 1000);
  }

  startTimer();

            
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (e) => {
    let checkoutBtn = e.target.closest("#checkout3");
    if (!checkoutBtn) return;
    checkoutBtn.classList.add("loading");
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    fetch('/cart.js')
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((cartData) => {
        const hasRecurpayItem = cartData.items?.some(
          (item) => item.properties && item.properties._PlanId
        );
        if (typeof window.recurpay?.recurCart == 'function' && hasRecurpayItem) {
          recurpay.recurCart(cartData);
           setTimeout(() => {
              checkoutBtn.classList.remove("loading");
          }, 5000);
          
        } else if (typeof openCheckout == "function") {
          openCheckout();
          checkoutBtn.classList.remove("loading");
        }
      })
      .catch((err) => {
        console.error("Error fetching cart data:", err);
      })
      
  });
});


  function handleMutations(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        if(document.querySelector("#checkout3")) {
          let checkoutBtn = document.querySelector("#checkout3");
          if (checkoutBtn) {
            checkoutBtn.removeAttribute("onclick");
          }
        }
      }
    }
  }
  const observer = new MutationObserver(handleMutations);
  observer.observe(document.body, { childList: true, subtree: true });

  window.initFloAuthFlow = async function () {
  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }
  const popup = document.querySelector(".community-popup");
  const welcomeCard = document.querySelector(".welcome-card");
  const name = document.querySelector(".name--user");
  const discountCookie = getCookie("discount_code");
  const nitroId = getCookie("nitrox");

  if (popup) popup.style.display = "none";
  if (welcomeCard) welcomeCard.style.display = "none";

  if (!nitroId) {
    console.log("No nitro cookie, skip auto-login");
    return;
  }
  try {
    const res = await fetch("https://crmapi.thegoodbug.com/v1.0/auth/check-nitro", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nitroId }),
    });

    const data = await res.json();
    console.log("Nitro check:", data);

    if (["found", "created"].includes(data?.status)) {
      if (!discountCookie) {
        if (welcomeCard) {
          if (popup) popup.style.display = "flex";
          welcomeCard.style.display = "block";
          if (name && data?.userData?.name) {
            name.textContent = data.userData.name;
          }

          welcomeCard.addEventListener("click", () => {
            document.cookie =
              "discount_code=PRIME10; path=/; max-age=" + 60 * 60 * 24 * 7;
            welcomeCard.style.display = "none";
            if (popup) popup.style.display = "none";
          });
        }
      } else {
        console.log("Discount already set, not showing welcome card");
      }
    }
  } catch (err) {
    console.error("Nitro check failed:", err);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  // window.initFloAuthFlow();
});
   document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
  var cart = document.querySelector("cart-drawer");
  var clickedElement = event.target;

  if (clickedElement.classList.contains('product-buttons2')) {
    let Att = clickedElement.getAttribute('rec-id');
    console.log("Att", Att);
    
    let data = [];
    data.push({
      'id': Att,
      'quantity': 1,
      'properties': {
        'utm_source':'Your-Gut-Will-Love-This-Cart'
      }
    });

    let formData = {
      'items': data,
      sections: cart.getSectionsToRender().map((section) => section.id),
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(resp => {
      cart.renderContents(resp);
      cart.classList.remove("is-empty");
    })
    .catch(error => {
      console.log("ERROR :", error);
    })
    .finally(() => {
      startTimer();
    });
  }
   else if (clickedElement.classList.contains('product-buttons-kefin')) {
    let Att = clickedElement.getAttribute('rec-id');
    console.log("Att", Att);
    
    let data = [];
    data.push({
      'id': Att,
      'quantity': 6,
      'properties': {
        'utm_source':'Your-Gut-Will-Love-This-Cart'
      }
    });

    let formData = {
      'items': data,
      sections: cart.getSectionsToRender().map((section) => section.id),
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(resp => {
      cart.renderContents(resp);
      cart.classList.remove("is-empty");
    })
    .catch(error => {
      console.log("ERROR :", error);
    })
    .finally(() => {
      // startTimer();
    });
  }    
});

  });

//     document.addEventListener('DOMContentLoaded', function() {
//     document.body.addEventListener('click', function(event) {
//   var cart = document.querySelector("cart-drawer");
//   var clickedElement = event.target;

//   if (clickedElement.classList.contains('product-buttons2')) {
//     let Att = clickedElement.getAttribute('rec-id');
//     console.log("Att", Att);
    
//     let data = [];
//     data.push({
//       'id': Att,
//       'quantity': 1,
//       'properties': {
//         'utm_source':'Faster-Result-With-Cart'
//       }
//     });

//     let formData = {
//       'items': data,
//       sections: cart.getSectionsToRender().map((section) => section.id),
//     };

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         Accept: 'application/json',
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(response => response.json())
//     .then(resp => {
//       cart.renderContents(resp);
//       cart.classList.remove("is-empty");
//     })
//     .catch(error => {
//       console.log("ERROR :", error);
//     })
//     .finally(() => {
//       startTimer();
//     });
//   }
//   else if (clickedElement.classList.contains('product-buttons-kefin')) {
//     let Att = clickedElement.getAttribute('rec-id');
//     console.log("Att", Att);
    
//     let data = [];
//     data.push({
//       'id': Att,
//       'quantity': 6,
//       'properties': {
//         'utm_source':'Faster-Result-With-Cart'
//       }
//     });

//     let formData = {
//       'items': data,
//       sections: cart.getSectionsToRender().map((section) => section.id),
//     };

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         Accept: 'application/json',
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(response => response.json())
//     .then(resp => {
//       cart.renderContents(resp);
//       cart.classList.remove("is-empty");
//     })
//     .catch(error => {
//       console.log("ERROR :", error);
//     })
//     .finally(() => {
//       // startTimer();
//     });
//   }
// });

//   });


document.addEventListener("DOMContentLoaded", function () {
  const stickBtn = document.querySelector(".stick-btn");
  const fixBtn = document.querySelector(".fix-btn");

  if (!stickBtn || !fixBtn) return;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function handleScroll(e) {
    e.stopImmediatePropagation();
    e.preventDefault();

    if (isInViewport(stickBtn)) {
      fixBtn.style.display = "none";
    } else {
      fixBtn.style.display = "flex";
    }
  }

  window.addEventListener("scroll", handleScroll, { passive: false });
  handleScroll();
});

document.addEventListener("DOMContentLoaded", function () {
  const mappings = [
    { fix: ".cta-12week-fix", target: ".cta-12week" },
    { fix: ".cnslt-2-week-prog-fix", target: ".cnslt-2-week-prog" }
  ];

  mappings.forEach(pair => {
    const fixBtn = document.querySelector(pair.fix);
    const targetBtn = document.querySelector(pair.target);

    if (!fixBtn || !targetBtn) return;

    fixBtn.addEventListener("click", function (e) {
      e.preventDefault();
      targetBtn.click();
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const cartLink = document.getElementById("cart-icon-bubble");

  if (!cartLink) return;

  cartLink.addEventListener(
    "click",
    function (e) {
      e.preventDefault();              
      e.stopImmediatePropagation();    

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();            
      }
    },
    true 
  );
});

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(event) {
    const clickedElement = event.target;
    const Att = clickedElement.getAttribute('data-id');

    if (!Att) return; 

    const cart = document.querySelector("cart-drawer");
    if (!cart || !cart.getSectionsToRender) {
      console.error("Cart drawer or getSectionsToRender not found");
      return;
    }

    console.log("Att", Att);

    const data = [{
      id: Att,
      quantity: 1,
      properties: {
        utm_source: 'Mint'
      }
    }];

    const formData = {
      items: data,
      sections: cart.getSectionsToRender().map(section => section.id)
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(resp => {
      if (cart.renderContents) cart.renderContents(resp);
      cart.classList.remove("is-empty");
    })
    .catch(error => {
      console.error("ERROR:", error);
    })
    .finally(() => {
      if (typeof startTimer === 'function') startTimer();
    });
  });
});
// document.addEventListener('DOMContentLoaded', function() {
//   document.body.addEventListener('click', function(event) {

//     const clickedElement = event.target.closest('[data-id]');
//     if (!clickedElement) return;

//     const Att = clickedElement.getAttribute('data-id');

//     const cart = document.querySelector("cart-drawer");
//     if (!cart || !cart.getSectionsToRender) return;

//     const data = [{
//       id: Att,
//       quantity: 1,
//       properties: {
//         utm_source: 'Mint'
//       }
//     }];

//     const formData = {
//       items: data,
//       sections: cart.getSectionsToRender().map(section => section.id)
//     };

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         Accept: 'application/json',
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(response => response.json())
//     .then(resp => {
//       if (cart.renderContents) cart.renderContents(resp);
//       cart.classList.remove("is-empty");
//     })
//     .finally(() => {
//       if (typeof startTimer === 'function') startTimer();
//     });

//   });
// });
 // OneShotChallenge quantity guard in cart drawer
  // Prevents buyers from bypassing the CSS-hidden quantity control via DevTools
  (function() {
    function applyOneShotGuards() {
      document.querySelectorAll('tr.cart-item[cart-prdct-id]').forEach(function(row) {
        // Detect oneshotchallenge by checking the product URL in the item link
        var productLink = row.querySelector('a.cart-item__link, a.cart-item__name');
        if (!productLink) return;
        var href = productLink.getAttribute('href') || '';
        if (!href.includes('oneshotchallenge')) return;

        // Disable the + button
        var plusBtn = row.querySelector('button[name="plus"]');
        if (plusBtn) {
          plusBtn.disabled = true;
          plusBtn.style.pointerEvents = 'none';
          plusBtn.style.opacity = '0.4';
          plusBtn.setAttribute('aria-disabled', 'true');
        }

        // Lock the quantity input to max=1 and restore if bypassed
        var qtyInput = row.querySelector('input.quantity__input');
        if (qtyInput) {
          qtyInput.setAttribute('max', '1');
          qtyInput.setAttribute('readonly', '');
          if (parseInt(qtyInput.value) > 1) {
            qtyInput.value = '1';
          }
          // Also block programmatic changes
          qtyInput.addEventListener('change', function(e) {
            if (parseInt(e.target.value) > 1) {
              e.target.value = '1';
              e.stopImmediatePropagation();
              e.preventDefault();
            }
          }, true);
        }
      });
    }

    // Run on initial load
    document.addEventListener('DOMContentLoaded', applyOneShotGuards);

    // Re-run whenever the cart drawer items container re-renders
    document.addEventListener('DOMContentLoaded', function() {
      var cartItems = document.getElementById('CartDrawer-CartItems');
      if (!cartItems) return;
      new MutationObserver(function() {
        applyOneShotGuards();
      }).observe(cartItems, { childList: true, subtree: true });
    });
  })();

 

document.querySelector('h5.footer-block__heading.Contact.Us')?.addEventListener('click', function () {
  window.location.href = '/pages/contact-us';
});